import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const apiAccUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", 
  Authorization: getCookie("mawalog"),
};

//Asset Files Logs Listing
export const getFileApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `asset/attachment/` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Files Save

export const saveFileApi = async (id, body) => {
  try {
    const response = await axios.post(`${apiUrl}asset/attachment/${id}`, body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error saving file:", err.response?.data || err.message);
    return err.response;
  }
};

//Asset profile Page
export const getProfileViewApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `asset/profile/` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Asset View Page
export const getAssetViewApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `asset/view/` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Asset Gate Logs Listing
export const getGateApi = async (id, params) => {
  try {
    const response = await axios.get(`${apiUrl}asset/transaction/${id}`, {
      headers: header,
      params: params, 
    });
    return response;
  } catch (err) {
    console.error("Error fetching gate data:", err);
  }
};

//Asset Assigned History Listing
export const getHistoryApi = async (id, params) => {
  try {
    const response = await axios.get(`${apiUrl}asset/assign/${id}`, {
      headers: header,
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching history:", err);
  }
};

//Asset Data Entries Listing
export const getDataApi = async (id, params) => {
  try {
    const response = await axios.get(`${apiUrl}asset/date_entry/${id}`, {
      headers: header,
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching data entries:", err);
  }
};

//Asset Data Entries Listing
export const getValidationsApi = async (id, params) => {
  try {
    const response = await axios.get(`${apiUrl}asset/validation/${id}`, {
      headers: header,
      params: params, // Proper way to attach query params
    });
    return response;
  } catch (err) {
    console.error("Error fetching validations:", err);
  }
};

//AssetEdited History Listing
export const getEditedHistoryApi = async (id, params) => {
  try {
    const response = await axios.get(`${apiUrl}asset/activity/${id}`, {
      headers: header,
      params: params, // Axios builds query string here
    });
    return response;
  } catch (err) {
    console.error("Error fetching edited history:", err);
  }
};

//Reminder View Page
export const getReminderViewApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `reminder/` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
